(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ym-akademi15-invitation"] && !Shopify.designMode) return;
  try {
    (() => {
  const root=document.getElementById('YmAkademi15');
  if(!root)return;
  const dialog=root.querySelector('#YmAkademi15Dialog');
  const open=()=>{if(dialog&&!dialog.open)dialog.showModal()};
  const close=()=>{if(dialog&&dialog.open)dialog.close()};
  root.querySelector('.ym-yourmedya15__trigger').addEventListener('click',open);
  root.querySelectorAll('[data-ym-close]').forEach((button)=>button.addEventListener('click',close));
  dialog.addEventListener('click',(event)=>{if(event.target===dialog)close()});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-community-welcome"] && !Shopify.designMode) return;
  try {
    (() => {
    const invitation = document.getElementById('YmInboxInvitation');
    if (!invitation) return;

    try {
      const key = 'ym-inbox-invitation-v4';
      const state = JSON.parse(sessionStorage.getItem(key) || '{}');
      const initialMessage = invitation.querySelector('[data-initial-message]');
      const followUpMessage = invitation.querySelector('[data-follow-up-message]');
      const save = () => sessionStorage.setItem(key, JSON.stringify(state));
      const hide = () => { invitation.hidden = true; };
      const show = (followUp) => {
        if (state.dismissed) return;
        initialMessage.hidden = followUp;
        followUpMessage.hidden = !followUp;
        invitation.hidden = false;
      };

      invitation.querySelector('.ym-inbox-invitation__close').addEventListener('click', () => {
        state.dismissed = true;
        save();
        hide();
      });

      if (!state.initialShown && !state.dismissed) {
        window.setTimeout(() => {
          show(false);
          state.initialShown = true;
          save();
          window.setTimeout(hide, 14000);
        }, 3500);
      }
      if (!state.followUpShown && !state.dismissed) {
        window.setTimeout(() => {
          show(true);
          state.followUpShown = true;
          save();
          window.setTimeout(hide, 15000);
        }, 45000);
      }

      const insertInstructorLinks = () => {
        document.querySelectorAll('.nav-links, .mobile-content').forEach((navigation) => {
          if (navigation.querySelector('[data-ym-instructors-link]')) return;
          const link = document.createElement('a');
          link.href = '/pages/egitmenler';
          link.textContent = 'Eğitmenler';
          link.setAttribute('data-ym-instructors-link', '');
          if (navigation.classList.contains('nav-links')) {
            const item = document.createElement('li');
            item.className = 'nav-item';
            item.appendChild(link);
            const contact = Array.from(navigation.querySelectorAll('a')).find((node) => node.textContent.trim() === 'İletişim');
            if (contact && contact.closest('li')) contact.closest('li').before(item); else navigation.appendChild(item);
          } else {
            link.className = 'mobile-link-std';
            const contact = Array.from(navigation.querySelectorAll('a')).find((node) => node.textContent.trim() === 'İletişim');
            if (contact) contact.before(link); else navigation.appendChild(link);
          }
        });
      };
      insertInstructorLinks();
      new MutationObserver(insertInstructorLinks).observe(document.body, { childList: true, subtree: true });
    } catch (error) {
      invitation.remove();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-course-preview"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('ym-course-preview')) return;

    const getVideoId = (value) => {
      try {
        const url = new URL(value);
        if (url.protocol !== 'https:') return '';

        const host = url.hostname.toLowerCase().replace(/^www[.]/, '');
        const parts = url.pathname.split('/').filter(Boolean);
        const id = host === 'youtu.be'
          ? parts[0]
          : (['youtube.com', 'm.youtube.com', 'youtube-nocookie.com'].includes(host)
            ? (url.searchParams.get('v') || (['embed', 'shorts', 'live'].includes(parts[0]) ? parts[1] : ''))
            : '');

        return /^[A-Za-z0-9_-]{11}$/.test(id || '') ? id : '';
      } catch {
        return '';
      }
    };

    customElements.define('ym-course-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.videoId = getVideoId(this.dataset.videoUrl || '');
        if (!this.videoId) return;

        const productArea = this.closest('.product-information') || document;
        const gallery = productArea.querySelector('media-gallery') || document.querySelector('media-gallery');
        if (!gallery) return;

        const tile = document.createElement('button');
        tile.type = 'button';
        tile.className = 'ym-gallery-preview-tile';
        tile.setAttribute('aria-label', 'Ders önizlemesini aç');
        tile.innerHTML = '<span class="ym-gallery-preview-tile__icon" aria-hidden="true">▶</span><span class="ym-gallery-preview-tile__label">Önizleme</span>';
        tile.addEventListener('click', () => this.openPreview(tile));

        const strip = gallery.querySelector('.slideshow-controls__thumbnails-container');
        const thumbnailList = strip?.querySelector('.slideshow-controls__thumbnails') || strip;
        if (thumbnailList) {
          thumbnailList.append(tile);
          const keepTileLast = () => {
            if (tile.parentElement === thumbnailList && thumbnailList.lastElementChild !== tile) {
              thumbnailList.append(tile);
            }
          };
          const observer = new MutationObserver((records) => {
            const imageThumbnailWasAdded = records.some((record) =>
              Array.from(record.addedNodes).some((node) => node !== tile)
            );
            if (imageThumbnailWasAdded) window.requestAnimationFrame(keepTileLast);
          });
          observer.observe(thumbnailList, { childList: true });
          window.setTimeout(keepTileLast, 250);
          window.setTimeout(keepTileLast, 1000);
        } else {
          gallery.append(tile);
        }
      }

      openPreview(trigger) {
        document.getElementById('ym-course-preview-dialog')?.remove();

        const dialog = document.createElement('dialog');
        dialog.id = 'ym-course-preview-dialog';
        dialog.className = 'ym-preview-dialog';
        dialog.setAttribute('aria-label', (this.dataset.productTitle || 'Eğitim') + ' ders önizlemesi');

        const source = 'https://www.youtube-nocookie.com/embed/' + this.videoId + '?autoplay=1&playsinline=1&rel=0&modestbranding=1&enablejsapi=1&origin=' + encodeURIComponent(window.location.origin);
        dialog.innerHTML = '<button class="ym-preview-dialog__close" type="button" aria-label="Önizlemeyi kapat">×</button><div class="ym-preview-dialog__video"><iframe id="ym-preview-player" src="' + source + '" title="' + (this.dataset.productTitle || 'Eğitim') + ' ders önizlemesi" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen></iframe><div class="ym-preview-dialog__finish" data-preview-finish hidden><div class="ym-preview-dialog__finish-inner"><p>Önizleme bitti. Eğitimin tamamına hemen erişmek için satın alma adımına geçin.</p><button type="button" data-preview-purchase>Eğitime devam etmek için satın al</button></div></div></div>';

        const close = dialog.querySelector('.ym-preview-dialog__close');
        const finish = dialog.querySelector('[data-preview-finish]');
        const purchase = dialog.querySelector('[data-preview-purchase]');
        const playerFrame = dialog.querySelector('#ym-preview-player');
        let hasFinished = false;

        const showFinish = () => {
          if (hasFinished) return;
          hasFinished = true;
          finish.hidden = false;
          purchase.focus({ preventScroll: true });
        };

        const onPlayerMessage = (event) => {
          if (!/^https:\/\/(www\.)?youtube(-nocookie)?\.com$/.test(event.origin)) return;
          let data = event.data;
          if (typeof data === 'string') {
            try { data = JSON.parse(data); } catch { return; }
          }
          if (data && data.event === 'onStateChange' && Number(data.info) === 0) showFinish();
        };

        const subscribeToPlayer = () => {
          if (!playerFrame?.contentWindow) return;
          const payload = JSON.stringify({
            event: 'command',
            func: 'addEventListener',
            args: ['onStateChange'],
            id: 'ym-preview-player'
          });
          playerFrame.contentWindow.postMessage(payload, 'https://www.youtube-nocookie.com');
          playerFrame.contentWindow.postMessage(payload, 'https://www.youtube.com');
        };

        const startApiFallback = () => {
          const startPlayer = () => {
            if (!window.YT?.Player || !playerFrame?.isConnected) return;
            try {
              new window.YT.Player('ym-preview-player', {
                events: {
                  onStateChange: (event) => {
                    if (Number(event.data) === 0) showFinish();
                  }
                }
              });
            } catch {}
          };

          if (window.YT?.Player) {
            startPlayer();
            return;
          }

          const existing = document.querySelector('script[data-ym-youtube-api]');
          const previous = window.onYouTubeIframeAPIReady;
          window.onYouTubeIframeAPIReady = () => {
            if (typeof previous === 'function') previous();
            startPlayer();
          };

          if (!existing) {
            const api = document.createElement('script');
            api.src = 'https://www.youtube.com/iframe_api';
            api.async = true;
            api.dataset.ymYoutubeApi = 'true';
            document.head.append(api);
          }
        };

        playerFrame?.addEventListener('load', () => {
          subscribeToPlayer();
          window.setTimeout(subscribeToPlayer, 250);
          window.setTimeout(subscribeToPlayer, 900);
          startApiFallback();
        }, { once: true });

        window.addEventListener('message', onPlayerMessage);
        close.addEventListener('click', () => dialog.close());
        purchase.addEventListener('click', () => {
          dialog.close();
          window.setTimeout(() => {
            const productArea = document.querySelector('.product-information');
            const buyNow = productArea?.querySelector('.shopify-payment-button__button--unbranded');
            if (buyNow) {
              buyNow.click();
              return;
            }
            const addButton = productArea?.querySelector('button[name="add"], [ref="addToCartButton"]');
            if (!addButton) return;
            addButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
            addButton.focus({ preventScroll: true });
          }, 0);
        });
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => {
          window.removeEventListener('message', onPlayerMessage);
          dialog.remove();
          trigger.focus();
        });

        document.body.append(dialog);
        if (dialog.showModal) dialog.showModal();
        else dialog.setAttribute('open', '');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-inbox-performance"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ymInboxWarmupReady) return;
    window.ymInboxWarmupReady = true;

    const launcherSelectors = [
      'button[aria-label*="Mesaj"]',
      'button[aria-label*="mesaj"]',
      'button[aria-label*="Sohbet"]',
      'button[aria-label*="sohbet"]',
      '[data-shopify-inbox-launcher]',
      'shopify-inbox button'
    ].join(',');

    const cacheLauncher = () => {
      const launcher = document.querySelector(launcherSelectors);
      if (launcher) window.ymInboxLauncher = launcher;
      return launcher;
    };

    const observer = new MutationObserver(() => {
      if (cacheLauncher()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    const warm = () => {
      cacheLauncher();
      document.querySelectorAll('link[rel="preconnect"][href*="shopify"]').forEach((link) => {
        link.fetchPriority = 'high';
      });
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(warm, { timeout: 700 });
    } else {
      window.setTimeout(warm, 0);
    }

    window.addEventListener('pageshow', warm, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-marketing-proof"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.ymCatalogToastReady) return;
    window.ymCatalogToastReady = true;

    const toast = document.getElementById('YmCatalogToast');
    if (!toast) return;

    const items = Array.from(toast.querySelectorAll('[data-ym-catalog-item]'));
    if (!items.length) return;

    let index = Date.now() % items.length;
    let hideTimer;
    let showTimer;

    const isMuted = () => {
      try {
        return sessionStorage.getItem('ym-catalog-toast-muted') === 'true';
      } catch (error) {
        return false;
      }
    };

    const hide = () => {
      toast.classList.remove('is-visible');
      window.clearTimeout(hideTimer);
    };

    const schedule = (delay = 32000) => {
      window.clearTimeout(showTimer);
      showTimer = window.setTimeout(show, delay);
    };

    const show = () => {
      if (isMuted()) return;
      if (document.hidden) {
        schedule(10000);
        return;
      }

      items.forEach((item) => {
        item.hidden = true;
      });
      items[index].hidden = false;
      index = (index + 1) % items.length;
      toast.hidden = false;
      requestAnimationFrame(() => toast.classList.add('is-visible'));
      hideTimer = window.setTimeout(() => {
        hide();
        schedule();
      }, 6500);
    };

    toast.querySelector('[data-ym-catalog-close]')?.addEventListener('click', () => {
      hide();
      window.clearTimeout(showTimer);
      try {
        sessionStorage.setItem('ym-catalog-toast-muted', 'true');
      } catch (error) {}
    });

    schedule(10000);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ym-trust-badges"] && !Shopify.designMode) return;
  try {
    const setupViewerCounts = (scope = document) => {
    scope.querySelectorAll('[data-ym-viewer-count]:not([data-ym-ready])').forEach((indicator) => {
      indicator.setAttribute('data-ym-ready', 'true');

      const productId = indicator.dataset.productId || '0';
      const label = indicator.querySelector('[data-ym-viewer-label]');
      const template = indicator.dataset.labelTemplate || '__COUNT__';
      const seed = [...productId].reduce((total, character) => total + character.charCodeAt(0), 0);
      let count = 24 + ((seed + Math.floor(Date.now() / 300000)) % 23);

      const render = () => {
        if (label) label.textContent = template.replace('__COUNT__', String(count));
      };

      render();
      window.setInterval(() => {
        count = Math.max(18, Math.min(52, count + (Math.random() > 0.48 ? 1 : -1)));
        render();
      }, 12000);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupViewerCounts());
  } else {
    setupViewerCounts();
  }

  document.addEventListener('shopify:section:load', (event) => setupViewerCounts(event.target));
  } catch(e) { console.error(e); }
})();

})();
